import { helpers } from "vuelidate/lib/validators";

export function shouldBeYesIf(condition) {
  return helpers.withParams({ type: "shouldBeYesIf" }, function(value) {
    return !(value === 0 && condition);
  });
}
